export const COMPARE_CARS_STORAGE_KEY = "beepbeep_compare_car_ids_v1";
export const MAX_COMPARE_CARS = 3;

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Парсинг `?ids=uuid,uuid` из URL (безопасные UUID, максимум 3). */
export function parseCompareIdsFromParam(raw?: string | null): string[] {
  if (!raw?.trim()) return [];
  const next: string[] = [];
  const seen = new Set<string>();
  for (const part of raw.split(",")) {
    const id = part.trim().toLowerCase();
    if (!UUID_RE.test(id) || seen.has(id)) continue;
    seen.add(id);
    next.push(id);
    if (next.length >= MAX_COMPARE_CARS) break;
  }
  return next;
}

function parseIds(raw: string | null): string[] {
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return [];
    return arr.filter((x): x is string => typeof x === "string" && /^[0-9a-f-]{36}$/i.test(x)).slice(0, MAX_COMPARE_CARS);
  } catch {
    return [];
  }
}

export function readCompareCarIds(): string[] {
  if (typeof window === "undefined") return [];
  return parseIds(window.localStorage.getItem(COMPARE_CARS_STORAGE_KEY));
}

export function writeCompareCarIds(ids: string[]) {
  if (typeof window === "undefined") return;
  const clean = [...new Set(ids)].filter((id) => /^[0-9a-f-]{36}$/i.test(id)).slice(0, MAX_COMPARE_CARS);
  window.localStorage.setItem(COMPARE_CARS_STORAGE_KEY, JSON.stringify(clean));
  window.dispatchEvent(new Event("beepbeep-compare-change"));
}

/** true = добавлено, false = убрано или лимит */
export function toggleCompareCarId(carId: string): { ids: string[]; action: "added" | "removed" | "limit" } {
  const cur = readCompareCarIds();
  const ix = cur.indexOf(carId);
  if (ix >= 0) {
    const next = cur.filter((_, i) => i !== ix);
    writeCompareCarIds(next);
    return { ids: next, action: "removed" };
  }
  if (cur.length >= MAX_COMPARE_CARS) {
    return { ids: cur, action: "limit" };
  }
  const next = [...cur, carId];
  writeCompareCarIds(next);
  return { ids: next, action: "added" };
}

export function compareQueryFromIds(ids: string[]): string {
  return ids.slice(0, MAX_COMPARE_CARS).join(",");
}

